import { Badge } from "@/core/components/ui/badge";
import { NoTranslate } from "@/core/components/ui/no-translate";
import { cn } from "@/core/utils/func/cn";
import type { TransactionStatus } from "@/features/shared/api/enums";

/**
 * Couleurs de statut par tokens du design system (règle projet : jamais de
 * classes palette brutes) — surfaces `-muted` + teinte du token.
 */
const STATUS_STYLES: Record<TransactionStatus, string> = {
  PENDING: "border-warning/40 bg-warning-muted text-warning",
  AWAITING_LEDGER: "border-info/40 bg-info-muted text-info",
  COMPLETED: "border-success/40 bg-success-muted text-success",
  DISPUTED: "border-warning/40 bg-warning-muted text-warning",
  FAILED: "border-destructive/40 bg-destructive/10 text-destructive",
  REVERSED: "border-border bg-muted text-muted-foreground",
  CANCELLED: "border-border bg-muted text-muted-foreground",
};

/**
 * Badge de statut d'une transaction (énumération MAJUSCULES de l'annexe A,
 * affichée littéralement en `NoTranslate`).
 */
export function TransactionStatusBadge({ status }: { status: TransactionStatus }) {
  return (
    <NoTranslate as="span">
      <Badge variant="outline" className={cn(STATUS_STYLES[status])}>
        {status}
      </Badge>
    </NoTranslate>
  );
}
